import { useMutation } from "@tanstack/react-query";
import apiDal from "../config/apiDal";

type DeleteDimensionOptionPayload = {
	categoryDimensionOptionUid: string;
};

const deleteDimensionOption = async (payload: DeleteDimensionOptionPayload): Promise<any> => {
	const response = await apiDal.post("/categorydimensionoptions/delete", payload);
	return response.data;
};

export const useDeleteDimensionOption = () => {
	return useMutation({
		mutationFn: deleteDimensionOption,
	});
};
